/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable no-unused-vars */

//suggest improvements for this component


//ran this thru claudes code refactoring tool

// redesign this component to look more elegant and polished
// Use Tailwind CSS className only. Preserve all logic, Redux hooks, and routing exactly as-is.
// use tailwind css in the className directive 
// ask me a series of questions to gather additional context you need to best achive this task
// "Colors come from dynamic seller props — use hex + opacity string concatenation (e.g. sellerPrimaryColor1 + '20') for tints, never hardcode colors."
//     const { seller } = useSelector(state => state.seller)
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1

// Give me the complete code with instructions


import React, { useMemo } from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";

import GetSellerConfig from './GetSellerConfig';

const Pagination = ({ pageNumber, setPageNumber, totalItems, parPage, showItem }) => {
    //console.log('Rendering Pagination with:', { pageNumber, setPageNumber, totalItems, itemsPerPage, showItem });
    //console.log('Rendering Pagination with:', itemsPerPage);
    
    //const { seller } = useSelector(state => state.seller);
    //const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1 || '#16a34a';
    const { 
        seller, sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
    } = GetSellerConfig();

    const { totalPage, startPage, endPage } = useMemo(() => {
        const totalPage = Math.ceil(totalItems / parPage);
        let startPage = pageNumber;

        const dif = totalPage - pageNumber;
        if (dif <= showItem) startPage = totalPage - showItem;

        let endPage = startPage < 0 ? showItem : showItem + startPage;
        if (startPage <= 0) startPage = 1;

        // ✅ Clamp endPage so buttons never exceed totalPage
        if (endPage > totalPage) endPage = totalPage;

        return { totalPage, startPage, endPage };
    }, [totalItems, parPage, pageNumber, showItem]);

    const pageButtons = Array.from(
        { length: endPage - startPage + 1 },
        (_, idx) => startPage + idx
    );

    const activeStyle = {
        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark,
        color: '#ffffff',
        //boxShadow: `0 2px 12px ${sellerPrimaryColor1}40`,
        fontSize: '16px',
    };

    const inactiveStyle = {
        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
        color: sellerPrimaryColor1,
        border: `2px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
        fontSize: '16px',
    };

    const arrowStyle = {
        backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
        border: `2px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
        color: sellerPrimaryColor1 + sellerColorSuffixDark,
        fontSize: '16px',
    };

    const wrapperStyle = {
        backgroundColor: '#ffffff', //sellerPrimaryColor1 + sellerColorSuffixLight, //
        border: `2px solid ${sellerPrimaryColor1}${sellerColorSuffixMedium}`,
        //boxShadow: `0 1px 2px ${sellerPrimaryColor1}${sellerColorSuffixMedium}, 0 0 0 2px ${sellerPrimaryColor1}${sellerColorSuffixMedium}`,
        fontSize: '16px',
    };

    return (
        <nav aria-label="Pagination" className="bg-white rounded-full">
            <ul
                role="list"
                className="flex gap-1 items-center px-2 py-2 rounded-full"
                style={wrapperStyle}>
                {/* Prev */}
                {pageNumber > 1 && (
                    <li>
                        <button
                            onClick={() => setPageNumber(pageNumber - 1)}
                            aria-label="Go to previous page"
                            className="w-9 h-9 rounded-full flex items-center justify-center cursor-pointer transition-all duration-150 ease-out hover:scale-105 active:scale-95 focus:outline-none"
                            style={arrowStyle}>
                            <MdOutlineKeyboardDoubleArrowLeft size={20} aria-hidden="true" />
                        </button>
                    </li>
                )}

                {/* Ellipsis if startPage > 2 */}
                {startPage > 2 && (
                    <li>
                        <span
                            className="w-9 h-9 rounded-full flex items-center justify-center text-sm select-none"
                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                            …
                        </span>
                    </li>
                )}

                {/* Page buttons */}
                {pageButtons.map((page) => {
                    const isActive = pageNumber === page;
                    return (
                        <li key={page}>
                            <button
                                onClick={() => setPageNumber(page)}
                                aria-label={`Go to page ${page}`}
                                aria-current={isActive ? 'page' : undefined}
                                className={clsx(
                                    'w-9 h-9 rounded-full flex items-center justify-center text-sm font-medium cursor-pointer',
                                    'transition-all duration-150 ease-out focus:outline-none select-none',
                                    isActive
                                        ? 'scale-105'
                                        : 'hover:scale-105 active:scale-95'
                                )}
                                style={isActive ? activeStyle : inactiveStyle}>
                                {page}
                            </button>
                        </li>
                    );
                })}

                {/* Ellipsis if endPage < totalPage - 1 */}
                {endPage < totalPage - 1 && (
                    <li>
                        <span
                            className="w-9 h-9 rounded-full flex items-center justify-center text-sm select-none"
                            style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                            …
                        </span>
                    </li>
                )}

                {/* Next */}
                {pageNumber < totalPage && (
                    <li>
                        <button
                            onClick={() => setPageNumber(pageNumber + 1)}
                            aria-label="Go to next page"
                            className="w-9 h-9 rounded-full flex items-center justify-center cursor-pointer transition-all duration-150 ease-out hover:scale-105 active:scale-95 focus:outline-none"
                            style={arrowStyle}>
                            <MdOutlineKeyboardDoubleArrowRight size={20} aria-hidden="true" />
                        </button>
                    </li>
                )}
            </ul>
        </nav>
    );
};

export default Pagination;



//refactored code
// import React, { useMemo } from 'react';
// import clsx from 'clsx';
// import { MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";

// const btnBase = 'w-[33px] h-[33px] rounded-full flex justify-center items-center cursor-pointer transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-green-500';

// const Pagination = ({ pageNumber, setPageNumber, totalItems, itemsPerPage, showItem }) => {

//     const { totalPage, startPage, endPage } = useMemo(() => {
//         const totalPage = Math.ceil(totalItems / itemsPerPage);
//         let startPage = pageNumber;

//         const dif = totalPage - pageNumber;
//         if (dif <= showItem) startPage = totalPage - showItem;

//         let endPage = startPage < 0 ? showItem : showItem + startPage;
//         if (startPage <= 0) startPage = 1;

//         return { totalPage, startPage, endPage };
//     }, [totalItems, itemsPerPage, pageNumber, showItem]);

//     const pageButtons = Array.from(
//         { length: endPage - startPage + 1 },
//         (_, idx) => startPage + idx
//     );

//     return (
//         <nav aria-label="Pagination">
//             <ul role="list" className="flex gap-3 items-center">

//                 {pageNumber > 1 && (
//                     <li>
//                         <button
//                             onClick={() => setPageNumber(pageNumber - 1)}
//                             aria-label="Go to previous page"
//                             className={clsx(btnBase, 'bg-slate-300 text-black hover:bg-slate-400')}
//                         >
//                             <MdOutlineKeyboardDoubleArrowLeft aria-hidden="true" />
//                         </button>
//                     </li>
//                 )}

//                 {pageButtons.map((page) => (
//                     <li key={page}>
//                         <button
//                             onClick={() => setPageNumber(page)}
//                             aria-label={`Go to page ${page}`}
//                             aria-current={pageNumber === page ? 'page' : undefined}
//                             className={clsx(btnBase, pageNumber === page
//                                 ? 'bg-green-700 shadow-lg shadow-indigo-300/50 text-white'
//                                 : 'bg-slate-600 hover:bg-green-400 shadow-lg hover:shadow-indigo-500/50 text-[#d0d2d6]'
//                             )}
//                         >
//                             {page}
//                         </button>
//                     </li>
//                 ))}

//                 {pageNumber < totalPage && (
//                     <li>
//                         <button
//                             onClick={() => setPageNumber(pageNumber + 1)}
//                             aria-label="Go to next page"
//                             className={clsx(btnBase, 'bg-slate-300 text-black hover:bg-slate-400')}
//                         >
//                             <MdOutlineKeyboardDoubleArrowRight aria-hidden="true" />
//                         </button>
//                     </li>
//                 )}

//             </ul>
//         </nav>
//     );
// };

// export default Pagination;





//my original code
// import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';

// import { MdOutlineKeyboardDoubleArrowLeft,MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";

// const Pagination = ({pageNumber, setPageNumber, totalItems, parPage, showItem}) => {
//     const { seller } = useSelector(state => state.seller)

//     const sellerId = seller?._id 
//     const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1
    
//     let totalPage = Math.ceil(totalItems / parPage)
//     let startPage = pageNumber

//     let dif = totalPage - pageNumber
//     if (dif <= showItem) {
//         startPage = totalPage - showItem
//     }
//     let endPage = startPage < 0 ? showItem : showItem + startPage

//     if (startPage <= 0) {
//         startPage = 1
//     }

//     const createBtn = () => {

//         const btns = []
//         for (let i = startPage; i < endPage; i++) {
//             btns.push(
//                 <li key={i} onClick={()=>setPageNumber(i)} className={` ${pageNumber === i ? 
//                     'bg-green-700 shadow-lg shadow-indigo-300/50 text-white' : 
//                     'bg-slate-600 hover:bg-green-400 shadow-lg hover:shadow-indigo-500/50 text-[#d0d2d6]'} 
//                     w-[33px] h-[33px] rounded-full flex justify-center items-center cursor-pointer `}>
//                     {i}                    
//                 </li>
//             ) 
//         }
//         return btns
//     }

//     return (
//         <ul className='flex gap-3'>
//             {
//                 pageNumber > 1 && 
//                 <li onClick={() => setPageNumber(pageNumber - 1)} 
//                     className='w-[33px] h-[33px] rounded-full flex justify-center items-center bg-slate-300 
//                     text-[#000000] cursor-pointer'>
//                     <MdOutlineKeyboardDoubleArrowLeft />
//                 </li>
//             }
//             { createBtn() }
//             {
//                 pageNumber < totalPage && 
//                 <li onClick={() => setPageNumber(pageNumber + 1)} 
//                     className='w-[33px] h-[33px] rounded-full flex justify-center items-center bg-slate-300 
//                     text-[#000000] cursor-pointer'>
//                     <MdOutlineKeyboardDoubleArrowRight  />
//                 </li>
//             }
//         </ul>
//     )
// };

// export default Pagination;


